<template>
    <div>
      <b-container class="mt-5 mb-5">
        <b-button to="/manage/organisation/invoices" variant="primary" class="float-right">
          Bekijk facturen
        </b-button>
        <h1 class="fs-4 font-weight-bold mb-4">Financieel</h1>

        <div class="controls mb-2">
            <label>
                Selecteer jaar:
                <span class="d-inline-block w-20 ml-2" style="width:100px;">
                    <b-select v-model="fetchValue" @change="getFinancials">
                        <option v-for="year in years" :key="year">{{ year }}</option>
                    </b-select>
                </span>
            </label>
        </div>
        
        <b-card class="mb-3" no-body>
            <b-card-header>
                <h3 class="fs-5 mb-0">
                    Omzet <small>(incl. btw)</small>
                </h3>
            </b-card-header>
            <b-card-body>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Maand</th>
                            <th>Orders</th>
                            <th>Tickets</th>
                            <th>Omzet</th>
                            <th>Donaties</th>
                            <th>Servicekosten</th>
                            <th>Platformkosten</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template >
                            <tr v-for="(item, key) in financials" :key="key">
                                <td>{{ getMonth(item.month) }}</td>
                                <td>{{ item.total_orders - item.total_orders_canceled }} / <span class="text-danger">{{ item.total_orders_canceled }}</span></td>
                                <td>{{ item.total_tickets - item.total_tickets_canceled }} / <span class="text-danger">{{ item.total_tickets_canceled }}</span></td>
                                <td>{{ item.total_price|toCurrency }}</td>
                                <td>{{ item.total_donation_fee|toCurrency }}</td>
                                <td>{{ item.total_service_fee|toCurrency }}</td>
                                <td>{{ item.total_platform_fee|toCurrency }}</td>
                            </tr>
                        </template>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td class="font-weight-bold"></td>
                            <td class="font-weight-bold">{{ totalOrders }} / <span class="text-danger">{{ totalOrdersCanceled }}</span></td>
                            <td class="font-weight-bold">{{ totalTickets }} / <span class="text-danger">{{ totalTicketsCanceled }}</span></td>
                            <td class="font-weight-bold">{{ totalPrice|toCurrency }}</td>
                            <td class="font-weight-bold">{{ totalDonation|toCurrency }}</td>
                            <td class="font-weight-bold">{{ totalServiceCosts|toCurrency }}</td>
                            <td class="font-weight-bold">{{ totalCosts|toCurrency }}</td>
                        </tr>
                    </tfoot>
                </table>
            </b-card-body>
        </b-card>

      </b-container>
    </div>
  </template>
  
  <script>
    import moment from 'moment';

    export default {
        metaInfo: {
            title: 'Financieel',
        },
        components: {},
        data() {
            return {
                fetchMode: 'year',
                fetchValue: 2025,
                years: [2022, 2023, 2024, 2025, 2026],
                months: ['apr', 'mei', 'jun'],
                financials: {}
            }
        },
        computed: {
            totalOrders() {
                let total = 0;

                const items = Object.values(this.financials || {});

                if (items) {
                    items.forEach( item => {
                        total += Number(item.total_orders - item.total_orders_canceled);
                    })
                }
                return total;
            },
            totalOrdersCanceled() {
                let total = 0;

                const items = Object.values(this.financials || {});

                if (items) {
                    items.forEach( item => {
                        total += Number(item.total_orders_canceled);
                    })
                }
                return total;
            },
            totalTickets() {
                let total = 0;

                const items = Object.values(this.financials || {});

                if (items) {
                    items.forEach( item => {
                        total += Number(item.total_tickets - item.total_tickets_canceled);
                    })
                }
                return total;
            },
            totalTicketsCanceled() {
                let total = 0;

                const items = Object.values(this.financials || {});

                if (items) {
                    items.forEach( item => {
                        total += Number(item.total_tickets_canceled);
                    })
                }
                return total;
            },
            totalPrice() {
                let total = 0;

                const items = Object.values(this.financials || {});

                if (items) {
                    items.forEach( item => {
                        total += Number(item.total_price);
                    })
                }
                return total;
            },
            totalDonation() {
                let total = 0;

                const items = Object.values(this.financials || {});

                if (items) {
                    items.forEach( item => {
                        total += Number(item.total_donation_fee);
                    })
                }
                return total;
            },
            totalCosts() {
                let total = 0;

                const items = Object.values(this.financials || {});

                if (items) {
                    items.forEach( item => {
                        total += Number(item.total_platform_fee);
                    })
                }
                return total;
            },
            totalServiceCosts() {
                let total = 0;

                const items = Object.values(this.financials || {});

                if (items) {
                    items.forEach( item => {
                        total += Number(item.total_service_fee);
                    })
                }
                return total;
            },
        },
        methods: {
            getMonth: function(value) {
                return this.capitalizeFirstLetter(moment().month(value - 1).locale('nl').format('MMMM'));
            },
            capitalizeFirstLetter: function(val) {
                return String(val).charAt(0).toUpperCase() + String(val).slice(1);
            },
            getFinancials: function() {
                this.$axios.get("https://api.tixgo.nl/financials/" + this.fetchMode + "/" + this.fetchValue)
                    .then( response => {
                        if (response.data) {
                            this.financials = response.data;
                        }
                    }
                ).catch((reason) => {
                    console.log(reason);
                });
            },
        },
        created() {
           this.getFinancials();
        },
    }
</script>